import { useCallback } from 'react';
import { minBy } from 'lodash';

import { useQueryParams } from '@/hooks/router/use-query-params';

import { ListTops } from '../api/queries/list-tops';

import { DATA_EXPLORER_QUERY_PARAMS } from './constants';

interface UseDefaultFiltersParams {
  listTops: ReturnType<typeof ListTops.useQuery>;
  listUnits: {
    isSuccess: boolean;
    data?: {
      units: { id: string; label: string }[];
    };
  };
}

export function useDefaultFilters({
  listTops,
  listUnits,
}: UseDefaultFiltersParams) {
  const [_, queryParams] = useQueryParams(DATA_EXPLORER_QUERY_PARAMS);

  const selectFirstTop = useCallback(() => {
    if (!listTops.isSuccess) {
      return;
    }

    const firstTop = minBy(listTops.data?.tops, (t) => t.label);

    if (!firstTop) {
      return;
    }

    queryParams.replace({
      topId: firstTop.id,
    });
  }, [listTops.data?.tops, listTops.isSuccess, queryParams]);

  const selectFirstUnit = useCallback(() => {
    const unitId = minBy(listUnits.data?.units, (t) => t.label)?.id;
    if (listUnits.isSuccess && unitId) {
      queryParams.replace({
        unitIds: [unitId],
      });
    }
  }, [listUnits.isSuccess, queryParams, listUnits.data?.units]);

  return {
    selectFirstUnit,
    selectFirstTop,
  };
}
